import { render, staticRenderFns } from "./PageThank.vue?vue&type=template&id=387c29d2&"
import script from "./PageThank.vue?vue&type=script&lang=js&"
export * from "./PageThank.vue?vue&type=script&lang=js&"
import style0 from "./PageThank.vue?vue&type=style&index=0&id=387c29d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports